export default {"src":"/_next/static/media/bonaparte.00d1e39a.svg","height":80,"width":184,"blurWidth":0,"blurHeight":0};